module.exports = __webpack_public_path__ + "static/media/moto.f9676a27.svg";